import { ArchiveNodeOption } from "models/ArchiveNodeOption";
import "./UserServiceTreeItem.scss";

type Props = {
  selectedNode: ArchiveNodeOption;
  onNodeClick?: (
    service: ArchiveNodeOption,
    e: React.MouseEvent<HTMLElement, MouseEvent>
  ) => void;
};

export default function UserFpTreeItem({ selectedNode, onNodeClick }: Props) {
  const getClasses = () => {
    const classes = ["emptyFolder"];
    if (selectedNode.id === "fp") {
      classes.push("selected");
    }
    return selectedNode ? classes.join(" ") : "";
  };

  return (
    <li className={getClasses()}>
      <span
        onClick={(e) => {
          if (onNodeClick) {
            onNodeClick(
              {
                id: "fp",
                name: "Resultat & Analys",
                description: "",
                hidden: false,
                nodes: []
              },
              e
            );
          }
        }}
      >
        <span>Resultat & Analys</span>
      </span>
    </li>
  );
}
